<template lang='pug'>
.td.fp-tree-cell(:class='className', :style="{ width: grow }")
  .fp-tree-row-heads(v-if='isFirst')
    .fp-tree-row-head(
      v-for='n, index in [].constructor(item.level+1)',
      :class='{first: index===0,last: index===item.level, disable: item.hideLevels.indexOf(index)!= -1 }'
      :key='index'
    )
  span.content(:style='contentStyle')
    i.open-icon.fa.pointer(
      v-if='isFirst && haveChildren',
      @click='$emit("toggle")',
      :class="{'fa-plus': !item.open, 'fa-minus': item.open}"
    )
    i.icon(v-if='isFirst', :class='getIcon()')
    i.fa.fa-spin.fa-spinner.spinner(v-if='loading')
    fpui-input-text-editable.value(
      ref='editable',
      v-else-if='column.edit && !column.redirect',
      :value='value',
      :format='formatValue'
      :initialValue='formattedValue'
      @input='update($event, column.edit)'
    )
    component(
      v-else-if='component',
      :is='component.value',
      v-bind='component.props'
      @input='update($event, component.onInput)'
      @click='click($event, component.onClick)'
    )
    span.value(ref='value', v-else-if='column.redirect', v-html='value' @click='$router.push(column.redirect + item.id)')
    span.value(ref='value', v-else, v-html='value')
</template>

<script>
export default {
  props: {
    columnRatio: { type: Number },
    isFirst: { type: Boolean },
    isLast: { type: Boolean },
    index: { type: Number, required: true },
    value: { },
    options: { type: Object, required: true },
    item: { type: Object, required: true },
    root: { type: Object, required: true },
    columnItem: { type: Object, required: true }
  },
  data () {
    return {
      contentStyle: '',
      loading: false
    }
  },
  computed: {
    haveChildren () {
      if(typeof this.item.children === 'function') {
        return true
      }
      return this.item.children && this.item.children.length > 0
    },
    className () {
      let className = []
      if (this.column.class) className.push(this.column.class)
      if (this.isFirst) className.push('first')
      if (this.isActive) className.push('activeQuery')
      return className.join(' ')
    },
    column () {
      return this.options.type[this.item.type].columns[this.index] || {}
    },
    component () {
      if (typeof this.column.component !== 'function') return null
      return this.column.component(this.item)
    },
    formatValue () {
      if (typeof this.column.formatValue === 'function') {
        return this.column.formatValue.call(this, this.item, this.column, this.root)
      }
      return this.value
    },
    grow () {
      let grow = this.columnItem && this.columnItem.grow || 1
      return `${grow / this.columnRatio * 80}%`
    },
    isActive () {
      if (!this.$route.params.id) return false
      if (!this.item.id && this.item.type !== 'folder' && this.$route.params.id === 'new') return true
      return this.$route.params.id === this.item.id
    }
  },
  methods: {
    formattedValue (val) {
      if (val === '-') return ''
      return val
    },
    getIcon () {
      if (this.options.type[this.item.type].icons) {
        if (this.item.open) {
          return this.options.type[this.item.type].icons.open
        }
        return this.options.type[this.item.type].icons.close
      }
      return this.options.type[this.item.type].icon
    },
    refresh () { this.$forceUpdate() },
    update (value, fn) {
      if (typeof fn !== 'function') return Promise.reject(new Error('Not a function'))
      return Promise.resolve(fn.call(this, this.item, this.column, value, this.root))
        .then(() => {
          this.edit = false
          return this.renderCell()
        })
        .catch((err) => {
          console.error(err)
          throw err
        })
    },
    click (event, fn) {
      if (typeof fn !== 'function') return Promise.reject(new Error('Not a function'))
      return Promise.resolve(fn.call(this, this.item, this.column, event, this.root))
        .then(() => {
          this.edit = false
          return this.renderCell()
        })
    },
    renderCell () {
      if (this.isFirst) {
        this.contentStyle += `width:calc(100% - ${(this.item.level + 1) * 32}px);`
      }
      this.$emit('render')
    }
  }
}
</script>
